// extracted by mini-css-extract-plugin
export default {"root":"nvMxpj","product":"RDpvCA","image":"p3ew27","questionBlock":"uwdygX","title":"c5Qew1","productName":"iLwYcX","actionButtons":"X0g4hK","close":"_a5kPX","compact":"t5ZuGD"};